import { IconButton } from '@/components/Buttons';
import { View } from '@/components/Theme';
import { memo } from 'react';
import colors from '@/constants/Colors';
import isEqual from 'lodash/isEqual';

export const ResponseIcon = memo((props) => {

    const {
        icon = 'close', 
        iconSize = 20, 
        colorScheme = 'danger', 
        innerPadding = 20
    } = props;

    return (
        <View p={innerPadding} backgroundColor={ colors[colorScheme][100]} justifyContent={'center'} alignItems={'center'} rounded={'full'}>
            <View p={innerPadding} backgroundColor={ colors[colorScheme][500] } justifyContent={'center'} alignItems={'center'} rounded={'full'}>
                <IconButton size={iconSize} color={'white'} icon={icon} />
            </View>
        </View>
    )

}, isEqual);